import React, { useEffect, useState } from "react";
import axios from "axios";
import { optimizeImg } from "@/lib/img";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const inFlight = new Map(); // productId -> Promise

export default function SmartImage({ product, src, width = 480, alt, className, ...rest }) {
  const initial = optimizeImg(src || product?.image, width);
  const [current, setCurrent] = useState(initial);
  const [busy, setBusy] = useState(false);

  useEffect(() => { setCurrent(optimizeImg(src || product?.image, width)); }, [src, product?.image, width]);

  const handleError = () => {
    if (!product?.id || busy) return;
    setBusy(true);
    let p = inFlight.get(product.id);
    if (!p) {
      p = axios.post(`${API}/products/${product.id}/auto-image`).then((r) => r.data?.image);
      inFlight.set(product.id, p);
    }
    p.then((img) => {
      if (img) setCurrent(optimizeImg(img, width));
      else setCurrent("https://placehold.co/480x480/f3f4f6/9ca3af?text=Image+coming+soon");
    })
      .catch(() => setCurrent("https://placehold.co/480x480/f3f4f6/9ca3af?text=Image+coming+soon"))
      .finally(() => { setBusy(false); inFlight.delete(product.id); });
  };

  return (
    <>
      {busy && (
        <div className="absolute inset-0 bg-gray-100 animate-pulse grid place-items-center z-[1]" data-testid="smart-image-loading">
          <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">Loading image…</span>
        </div>
      )}
      <img
        src={current}
        alt={alt || product?.name || ""}
        loading="lazy"
        decoding="async"
        onError={handleError}
        className={className}
        {...rest}
      />
    </>
  );
}
